import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  AboutPage,
  BuisnessPage,
  ContactUsPage,
  Drivers,
  FaqPage,
  Home,
  HWork,
  IndividualsPage,
  Industries,
  LocationsPage,
  MultiFrom,
  PrivacyPage,
  SignIn,
  SignUp,
} from "./screens";
// import { Header2 } from "./components";

function App({ history }) {
  return (
    <Router>
      <Switch>
        <Route exact path="/register" component={SignUp} />
        <Route exact path="/login" component={SignIn} />
        <Route exact path="/" component={Home} />
        <Route exact path="/faq" component={FaqPage} />
        <Route exact path="/form" component={MultiFrom} />
        <Route exact path="/drivers" component={Drivers} />
        <Route exact path="/contactus">
          <ContactUsPage />
        </Route>
        <Route exact path="/individuals">
          <IndividualsPage />
        </Route>
        <Route exact path="/business">
          <BuisnessPage />
        </Route>
        <Route exact path="/howitwork">
          <HWork />
        </Route>
        <Route exact path="/privacy">
          <PrivacyPage />
        </Route>
        <Route exact path="/about">
          <AboutPage />
        </Route>
        <Route exact path="/industries">
          <Industries />
        </Route>
        <Route exact path="/location">
          <LocationsPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
